// eslint-disable-next-line
/* eslint-disable */
var axios = require('axios');

import { getToken, setToken, removeToken } from '../store/auth' 

// export const baseURL = 'http://localhost:3000/'
export const baseURL = 'https://iconerec.drmedpro.com.br/api/'  // drMedic Pro
// export const baseURL = 'http://10.0.0.10:3000/' // drMedic Pro
// export const baseURL = 'https://smv2.simplesmedic.com.br/' // drMedic Pro



export const api = axios.create({
    baseURL: baseURL,
    /* other custom settings */
    headers: {
        'Content-Type': 'application/json',
        'x-access-token': getToken()
    }
})

export const apiBot = axios.create({
    baseURL: 'https://simplesmedic.herokuapp.com/',
    /* other custom settings */
    headers: {
  'Content-Type': 'application/json',
  'x-access-token': getToken()
}
})

export const relatorioService = axios.create({
    // baseURL: 'http://localhost:8181/'
    baseURL: 'http://10.10.5.10:8080/'
})

/**
 * Configuração para conectar com a api de senhas do wi-fi
 */
export const apiWifi = axios.create({
    baseURL: 'http://10.0.0.69:3000/'
    
})

export const apiVoucher = axios.create({
    baseURL: 'https://iconesmi.drmedpro.com.br/',
    headers: {
        'Content-Type': 'application/json',
        'token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6OSwidXNlcm5hbWUiOiJkcm1lZHBybyIsImlhdCI6MTc1NDY2NTE4Nn0.nGkBYK9echPxVkAtztwPPMRHWh_shq0qAPs6Qv_ZNbo',
        
    }
})

/* export const apiVoucher = axios.create({
    baseURL: 'https://smi.cmremedios.com.br/',
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'token': 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI3LHJlcG9ydHMtZXZlcnRvbiwyMDI1LTA3LTA5IDIwOjQ5OjQ0In0.9oQPTmMOjzpSvmVSIy8fC0m4fUn2JcFMpLKhwLr6yF5qDP2xLxy_wdaZt3QWKZaaxx0i3lW0kD0EVft2vdzpZg',
        
    }
}) */

export const apiIA = axios.create({
    baseURL: 'https://iconeapi.drmedpro.com.br/',
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJmaWxhc212MiJ9.tnqUOJM5UtsuQ4oMd5jvzt5lLT610EUf56dWIecwDDE'
        }
    }) 



 /*export const apiIA = axios.create({
    baseURL: 'https://apipp.drmedpro.com.br/',
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJmaWxhc212MiJ9.tnqUOJM5UtsuQ4oMd5jvzt5lLT610EUf56dWIecwDDE'
        }
    })*/
